import axios from "axios";
import { config } from "../../../../config";


export const createReport = (payload) => {
    return new Promise((resolve, reject) => {
        axios.post(`${config.LOIS_BACKEND_URL}/google/reports/createReport`, {payload})
        .then((res) => {
            resolve(res)
        }).catch((err) => reject(err));
    })
}

export const getReports = (clientName) => {
    return new Promise((resolve, reject) => {
        axios.get(`${config.LOIS_BACKEND_URL}/google/reports/getReports?clientName=${clientName}`)
        .then((res) => {
            resolve(res)
        }).catch((err) => reject(err));
    })
}


export const deleteReport = (id) => {
    return new Promise((resolve, reject) => {
        axios.post(`${config.LOIS_BACKEND_URL}/google/reports/deleteReport`, {
            reportId: id
        })
        .then((res) => {
            resolve(res)
        }).catch((err) => reject(err));
    })
}


export const getReport = (id) => {
    return new Promise((resolve, reject) => {
        axios.get(`${config.LOIS_BACKEND_URL}/google/reports/getReport?reportId=${id}`)
        .then((res) => {
            resolve(res)
        }).catch((err) => reject(err));
    })
}


export const updateReport = (id, payload) => {
    return new Promise((resolve, reject) => {
        axios.post(`${config.LOIS_BACKEND_URL}/google/reports/updateReport`, {
            reportId: id,
            payload,
        })
        .then((res) => {
            resolve(res)
        }).catch((err) => reject(err));
    })
}